module.exports = __webpack_public_path__ + "static/img/6686_phase_function_Paper_PointsHejduk_Prediction.ab4e033.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6686_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Wre2
// module chunks = 0